module.exports = __webpack_public_path__ + "img/cont-03-consumo.f4317b51.svg";